import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// Hide initial loader once React is ready
setTimeout(() => {
  document.body.classList.add('loaded');
  // Remove loader from DOM after fade out
  setTimeout(() => {
    const loader = document.getElementById('initial-loader');
    const loaderContainer = document.querySelector('.loader-container');
    if (loader) {
      loader.remove();
    }
    if (loaderContainer) {
      loaderContainer.remove();
    }
  }, 300);
}, 800); // Increased from 100ms to 800ms to prevent freezing between loaders

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
